<template>
    <v-container fluid>
        <v-tabs color="secondary" class="mb-4">
            <v-tab :to="{ name: 'admin-overview' }" exact>Overview</v-tab>
            <v-tab v-if="isSysadmin" :to="{ name: 'admin-node-allocation' }" exact>Node allocation</v-tab>
        </v-tabs>
        <transition name="fadeonly" mode="out-in">
            <router-view></router-view>
        </transition>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
    computed: {
        ...mapGetters(['isSysadmin'])
    }
}
</script>
